import React from "react";
import { Pencil } from "lucide-react";

interface CanvasNodeCardProps {
  title: string;
  subtitle?: string;
  onEdit?: () => void;
  isGlobal?: boolean;
  highlightGlobal?: boolean;
}

export default function CanvasNodeCard({
  title,
  subtitle,
  onEdit,
  isGlobal,
  highlightGlobal = false,
}: CanvasNodeCardProps) {
  const LIMIT = 52;
  const displayTitle =
    title.length > LIMIT ? title.slice(0, LIMIT) + "..." : title;
  const cardBgClass =
    highlightGlobal && isGlobal ? "bg-yellow-50 border-yellow-300" : "bg-white";
  const headerBgClass = highlightGlobal && isGlobal ? "bg-yellow-100" : "";
  return (
    <div
      className={[
        "border rounded shadow-sm w-56 text-left hover:shadow-md transition-shadow",
        cardBgClass,
      ].join(" ")}
    >
      <div
        className={[
          "px-3 py-2 font-semibold border-b flex items-center justify-between gap-2 min-w-0",
          headerBgClass,
        ].join(" ")}
      >
        <span className="block truncate flex-1 min-w-0" title={title}>
          {displayTitle}
        </span>
        {onEdit && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
            onMouseDown={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            className="p-1 rounded hover:bg-gray-100 shrink-0"
            title="Edit node"
            aria-label="Edit node"
          >
            <Pencil className="h-4 w-4 text-gray-600" />
          </button>
        )}
      </div>
      {subtitle && (
        <div
          className="px-3 py-2 text-sm text-gray-600 truncate"
          title={subtitle}
        >
          {subtitle}
        </div>
      )}
    </div>
  );
}
